import { createStyles, makeStyles } from '@material-ui/core'

export default makeStyles((theme) =>
  createStyles({
    modalHeadline: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
    teaser: {
      color: theme.palette.getContrastText(theme.palette.primary.main),
    },
    dialogListWrapper: {
      paddingInlineStart: theme.spacing(2),
    },
    disclaimer: {
      lineHeight: 0.5,
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[100],
      padding: theme.spacing(2),
      '& span': {
        lineHeight: 1.2,
      },
    },
    moreDetails: {
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(10),
        '& svg': {
          fontSize: theme.typography.pxToRem(18),
        },
      },
    },
  })
)
